import {
    VIEW_IDEAS,
    ADD_IDEAS,
    UPDATE_IDEA,
    DELETE_IDEA,
    UPDATE_IDEA_STATUS,
    SELECTED_IDEA,
} from '../constants/action-types/ideas';

export const setIdeas = (ideas) => {
    return {
        type: VIEW_IDEAS,
        payload: ideas ?? [],
    };
};

export const addIdea = (idea) => {
    return {
        type: ADD_IDEAS,
        payload: idea,
    };
};

export const onSelectedIdea = (data) => {
    return {
        type: SELECTED_IDEA,
        payload: data
    };
};

export const onUpdateIdea = (updatedIdea) => {
    return {
        type: UPDATE_IDEA,
        payload: updatedIdea,
    };
};

export const updateIdeaStatus = (ideaId, status) => {
    return {
        type: UPDATE_IDEA_STATUS,
        payload: { ideaId, status }
    }
};

export const deleteIdea = (ideaId) => {
    return {
        type: DELETE_IDEA,
        payload: ideaId,
    }
};
